<template>
	<component :is="tag" ref="elm" @click="blockClickEvent"><slot></slot></component>
</template>

<script setup lang="ts">
import {ref, computed, watch, onUnmounted} from "vue";
import type {Chain} from "@/ui/paneltree/PanelTree";
import {debounce} from "@/utils/Debounce.ts";

const props = withDefaults(defineProps<{
	tag?: any,
	chain: Chain
}>(), {
	tag: "span"
});
//const emit = defineEmits([""]);
const elm = ref<HTMLElement | null>(null);
/* Calculate real root element (works for components) */
const root = computed<HTMLElement | null>(() => {
	const elementOrComponent = elm.value;
	if (elementOrComponent == null) return null;
	return elementOrComponent.$el ? elementOrComponent.$el : elementOrComponent;
});

function blockClickEvent(e:MouseEvent):void {
	// Prevent closing all panels on body-click
	e.stopPropagation();
}

watch(() => root.value, (el) => {
	if (props.chain) {
		props.chain.anchorElement.value = el;
		if (el) startObserving(el);
		else stopObserving();
	}
});

function element():HTMLElement|null {
	return root.value
}

let resizeObserver = null;

const resizeCallback = debounce(() => {
	if (props.chain) props.chain.update();
}, 100);

function startObserving(el:HTMLElement) {
	if (resizeObserver == null) {
		resizeObserver = new ResizeObserver(resizeCallback);
		resizeObserver.observe(el);
		if (props.chain) props.chain.update();
	}
}

function stopObserving() {
	if (resizeObserver != null) {
		resizeObserver.disconnect();
		resizeObserver = null;
	}
}

onUnmounted(() => {
	stopObserving();
});


defineExpose({ element });
</script>

<style>

</style>
